/** Definición de tipos de dato y constantes del estándar JSON API - http://jsonapi.org/format */

// Estados posibles al obtener data de la API
export const RESP_STATUS = {
	no_init: 'not_initialized',
	waiting: 'wating',
	ok: 'ok',
	error: 'error'
};
export const HTTP_STATUS_CODES = {
	error_auth: 401,
	error_permiso: 403,
	not_found: 404,
	validation_error: 422
};
export const API_ERROR_CODES = {
	validation: 'validation_error'
};

// Respuesta de JSON-API con un recurso o arreglo de recursos - http://jsonapi.org/format/#document-top-level
export interface JsonApiResponse extends Object {
	data: JsonApiRecurso | JsonApiRecurso[];
	meta?: any;
	links?: { [name: string]: JsonApiLink };
	included?: JsonApiRecurso[];
}
// Defino los siguientes dos tipos para cuando se sabe si la respuesta contiene un objeto único o un arreglo
export interface JsonApiResponseRecurso extends JsonApiResponse {
	data: JsonApiRecurso;
}
export interface JsonApiResponseRecursos extends JsonApiResponse {
	data: JsonApiRecurso[];
}

// Recurso (objeto correspondiente a un ApiModel) contenido en una respuesta de JSON-API
//  http://jsonapi.org/format/#document-resource-objects
export interface JsonApiRecurso extends Object {
	id?: number; // es opcional ya que si el recurso se crea en frontend no tiene id
	type: string;
	attributes?: any;
	relationships?: { [name: string]: JsonApiRelacion };
	links?: { [name: string]: JsonApiLink };
	meta?: any;
}
// Relación (to-one o to-many) de un recurso con otros - http://jsonapi.org/format/#document-resource-object-relationships
export interface JsonApiRelacion extends Object {
	data?: JsonApiRecurso | JsonApiRecurso[];
	links?: { [name: string]: JsonApiLink };
	meta?: any;
}
// Link: objeto con href y opcionalmente method y descripcion - http://jsonapi.org/format/#document-links
export interface JsonApiLink extends Object {
	href: string; // url a web o endpoint
	method?: string; // Valores posibles: "web" (si es link a plataforma), "GET", "POST", "PUT", "DELETE"
	descripcion?: string;
	meta?: string;
	url_placeholders?: string[];
}
// Respuesta error
export interface JsonApiResponseError {
	errors: JsonApiError[];
}
// Formato de error (incluido en respuesta con status code de error, dentro de arreglo errors)
export interface JsonApiError extends Object {
	status?: string | number;
	code?: string;
	title?: string;
	detail?: string;
	id?: string;
	links?: { [name: string]: JsonApiLink };
	meta?: any;
}


// Constantes usadas en promise rejected y errores
export const PREFIX_API_ERROR = 'api_error';
export const API_ERROR_GENERICO = PREFIX_API_ERROR;
export const API_ERROR_URL = PREFIX_API_ERROR + '_url';
export const API_ERROR_INVALID_DATA = PREFIX_API_ERROR + '_invalid_data';
export const API_ERROR_OFFLINE = PREFIX_API_ERROR + '_offline';
export const API_ERROR_AUTH = PREFIX_API_ERROR + '_auth';
export const API_ERROR_USER = PREFIX_API_ERROR + '_user';
export const API_ERROR_UF = PREFIX_API_ERROR + '_uf';
export const API_ERROR_UF_SIN_ACCESO = PREFIX_API_ERROR + '_uf_forbidden';
export const API_ERROR_UPDATE = PREFIX_API_ERROR + '_update';
export const API_ERROR_DESCARGA = PREFIX_API_ERROR + '_descarga';
export const API_ERROR_DESCARGA_SIN_URL = PREFIX_API_ERROR + '_descarga_sin_url';
export const API_ERROR_INVALID_PDF = PREFIX_API_ERROR + '_invalid_pdf';

// ToDo mejorar, revisar mensajes
export function getApiErrorDetail(error_code) {
	switch (error_code) {
	case API_ERROR_OFFLINE:
		return 'No hay conexión a internet: no se puede obtener información actualizada.';
	case API_ERROR_AUTH:
		return 'Sesión inválida: no pudo obtenerse la información. Volvé a iniciar sesión.';
	case API_ERROR_USER:
		return 'No pudo obtenerse información actualizada de tu usuario y tus unidades funcionales. Intentá de nuevo.';
	case API_ERROR_UF:
		return 'No pudo obtenerse información actualizada de la unidad funcional. Intentá de nuevo más tarde.';
	case API_ERROR_UF_SIN_ACCESO:
		return 'No tenés acceso a la información de esta unidad funcional. Contactate con tu administrador.';
	case API_ERROR_UPDATE:
		return 'No pudo obtenerse información actualizada. Intentá de nuevo más tarde.';
	case API_ERROR_DESCARGA:
	case API_ERROR_DESCARGA_SIN_URL:
		return 'No se pudo descargar el archivo solicitado. Intentá de nuevo más tarde.';
	case API_ERROR_INVALID_PDF:
		return 'El archivo solicitado no es un PDF válido. No se puede descargar.';
	case API_ERROR_INVALID_DATA:
	default:
		return 'Ocurrió un error en la comunicación con el servidor. Volvé a intentar.';
	}
}


export const PREFIX_STORAGE_ERROR = 'api_error';
export const STORAGE_ERROR = PREFIX_STORAGE_ERROR;
export const STORAGE_ERROR_KEY = PREFIX_STORAGE_ERROR + '_key';
export const STORAGE_ERROR_SIN_DATA = PREFIX_STORAGE_ERROR + '_sin_data';
export const STORAGE_ERROR_INCONSISTENCIA = PREFIX_STORAGE_ERROR + '_inconsistencia';